import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import EmployeesPage from "@/pages/EmployeesPage";
import EmployeeDetailPage from "@/pages/EmployeeDetailPage";
import DobGate from "@/components/DobGate";
import AttendancePage from "@/pages/AttendancePage";
import LeavesPage from "@/pages/LeavesPage";
import NotificationsPage from "@/pages/NotificationsPage";
import HolidaysPage from "@/pages/HolidaysPage";
import RegularizationsPage from "@/pages/RegularizationsPage";
import PayslipsPage from "@/pages/PayslipsPage";
import CompanySettingsPage from "@/pages/CompanySettingsPage";
import AttendanceImportPage from "@/pages/AttendanceImportPage";
import OnboardingPage from "@/pages/OnboardingPage";
import MyProfilePage from "@/pages/MyProfilePage";
import ApprovalsPage from "@/pages/ApprovalsPage";
import ConsultantsPage from "@/pages/ConsultantsPage";
import StaffingPage from "@/pages/StaffingPage";
import StaffingLoginPage from "@/pages/StaffingLoginPage";
import StaffingSetPasswordPage from "@/pages/StaffingSetPasswordPage";
import StaffingPortalPage from "@/pages/StaffingPortalPage";
import ConsultantPortalPage from "@/pages/ConsultantPortalPage";
import ConsultantLoginPage from "@/pages/ConsultantLoginPage";
import ConsultantInvitePage from "@/pages/ConsultantInvitePage";
import ConsultantSetPasswordPage from "@/pages/ConsultantSetPasswordPage";
import { Toaster } from "@/components/ui/sonner";

function Shell({ children }) {
  return <AppShell><DobGate>{children}</DobGate></AppShell>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<ProtectedRoute><Shell><DashboardPage /></Shell></ProtectedRoute>} />
            <Route path="/employees" element={<ProtectedRoute roles={["admin", "manager"]}><Shell><EmployeesPage /></Shell></ProtectedRoute>} />
            <Route path="/employees/:id" element={<ProtectedRoute roles={["admin", "manager"]}><Shell><EmployeeDetailPage /></Shell></ProtectedRoute>} />
            <Route path="/attendance" element={<ProtectedRoute><Shell><AttendancePage /></Shell></ProtectedRoute>} />
            <Route path="/attendance/import" element={<ProtectedRoute roles={["admin", "manager"]}><Shell><AttendanceImportPage /></Shell></ProtectedRoute>} />
            <Route path="/notifications" element={<ProtectedRoute><Shell><NotificationsPage /></Shell></ProtectedRoute>} />
          <Route path="/leaves" element={<ProtectedRoute><Shell><LeavesPage /></Shell></ProtectedRoute>} />
            <Route path="/regularizations" element={<ProtectedRoute><Shell><RegularizationsPage /></Shell></ProtectedRoute>} />
            <Route path="/holidays" element={<ProtectedRoute><Shell><HolidaysPage /></Shell></ProtectedRoute>} />
            <Route path="/payslips" element={<ProtectedRoute><Shell><PayslipsPage /></Shell></ProtectedRoute>} />
            <Route path="/company" element={<ProtectedRoute roles={["admin"]}><Shell><CompanySettingsPage /></Shell></ProtectedRoute>} />
            <Route path="/onboarding" element={<ProtectedRoute roles={["employee"]}><OnboardingPage /></ProtectedRoute>} />
            <Route path="/me" element={<ProtectedRoute roles={["employee", "manager", "admin"]}><Shell><MyProfilePage /></Shell></ProtectedRoute>} />
            <Route path="/consultants" element={<ProtectedRoute roles={["admin"]}><Shell><ConsultantsPage /></Shell></ProtectedRoute>} />
          <Route path="/staffing" element={<ProtectedRoute roles={["admin"]}><Shell><StaffingPage /></Shell></ProtectedRoute>} />
          {/* Contractors sign in on their own page, separate from employees and consultants. */}
          <Route path="/staffing/login" element={<StaffingLoginPage />} />
          <Route path="/staffing/set-password" element={<StaffingSetPasswordPage />} />
          <Route path="/staffing/portal" element={<ProtectedRoute roles={["staffing"]}><StaffingPortalPage /></ProtectedRoute>} />
            <Route path="/consultant/login" element={<ConsultantLoginPage />} />
          <Route path="/set-password" element={<ConsultantInvitePage />} />
            <Route path="/consultant/set-password" element={<ProtectedRoute roles={["consultant"]}><ConsultantSetPasswordPage /></ProtectedRoute>} />
            <Route path="/consultant" element={<ProtectedRoute roles={["consultant"]}><ConsultantPortalPage /></ProtectedRoute>} />
            <Route path="/consultant/onboarding" element={<ProtectedRoute roles={["consultant"]}><ConsultantPortalPage /></ProtectedRoute>} />
            <Route path="/approvals" element={<ProtectedRoute roles={["admin"]}><Shell><ApprovalsPage /></Shell></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
